import * as Yup from 'yup';

const validationSchema = Yup.object({
    code: Yup.string()
        .required('Código é obrigatório')
        .length(6, 'Código deve ter 6 caracteres'),
});

export default validationSchema;